import { useEffect, useState } from "react";
import { X, Search } from "lucide-react";
import { api } from "../lib/api";

const inputCls = "bg-[#0F0F0F] border border-white/10 text-white text-sm px-3 py-2.5 rounded-sm focus:outline-none focus:border-[#D4AF37]";

export const LeadSearch = ({ onPick, onBack, onClose, busy }) => {
  const [leads, setLeads] = useState(null);
  const [q, setQ] = useState("");

  useEffect(() => { api.get("/admin/attendance/leads").then((r) => setLeads(r.data)).catch(() => setLeads([])); }, []);

  const shown = (leads || []).filter((l) => `${l.name} ${l.phone || ""} ${l.trial_no || ""}`.toLowerCase().includes(q.toLowerCase()));

  return (
    <div className="bg-[#0A0A0A] border border-white/10 p-6 sm:p-8 w-full max-w-2xl max-h-[80vh] flex flex-col" data-testid="lead-search-panel">
      <div className="flex justify-between items-start mb-4">
        <div>
          <p className="text-[10px] tracking-[0.25em] uppercase text-blue-300 font-semibold">Lead Attending Trial</p>
          <h2 className="font-heading text-xl font-black mt-1">Pick from Leads</h2>
        </div>
        <button onClick={onClose} className="text-white/50 hover:text-white" data-testid="lead-pick-close"><X size={20} /></button>
      </div>
      <div className="relative mb-4">
        <Search size={16} className="text-white/40 absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none" />
        <input autoFocus placeholder="Search lead name or phone…" value={q} onChange={(e) => setQ(e.target.value)} className={inputCls + " w-full pl-10"} data-testid="lead-pick-search" />
      </div>
      <div className="flex-1 overflow-y-auto space-y-1.5 min-h-[200px]" data-testid="lead-pick-results">
        {leads === null && <p className="text-white/40 text-xs">Loading…</p>}
        {leads && shown.length === 0 && <p className="text-white/40 text-sm text-center py-6">No open leads match.</p>}
        {shown.map((l) => (
          <button key={l.id} disabled={busy} onClick={() => onPick(l)}
            className="w-full text-left border border-white/10 bg-[#050505] hover:border-blue-400 hover:bg-blue-400/5 p-3 transition-colors duration-200 disabled:opacity-40"
            data-testid={`lead-pick-${l.id}`}>
            <p className="font-semibold text-sm">{l.name} <span className="text-blue-300 text-xs ml-1">{l.trial_no}</span></p>
            <p className="text-white/40 text-xs mt-0.5">{[l.phone, l.batch, l.year_of_birth && `YoB ${l.year_of_birth}`, l.lead_status].filter(Boolean).join(" · ")}</p>
          </button>
        ))}
      </div>
      <button onClick={onBack} className="mt-4 text-[11px] uppercase tracking-widest text-white/40 hover:text-[#D4AF37] self-start" data-testid="lead-pick-back">← Back</button>
    </div>
  );
};
